function Browser() {
  //var app= navigator.appVersion;
  var language = (window.navigator.userLanguage || window.navigator.language).toLowerCase();
  var versions = {};
  var platform = 'Unknown';

  function getVersions() {
    var ua = window.navigator.userAgent;
    return {         //移动终端浏览器版本信息
      trident: ua.indexOf('Trident') > -1, //IE内核
      presto: ua.indexOf('Presto') > -1, //opera内核
      webKit: ua.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: ua.indexOf('Gecko') > -1 && ua.indexOf('KHTML') == -1, //火狐内核
      mobile: !!ua.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      iOS: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      Android: ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1, //android终端或uc浏览器
      iPhone: ua.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: ua.indexOf('iPad') > -1, //是否iPad
      webApp: ua.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
    };
  }

  function getPlatform() {
    if (versions.mobile) {
      var ua = window.navigator.userAgent.toLowerCase();//获取判断用的对象
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return 'weixin';
      }
      if (ua.match(/WeiBo/i) == "weibo") {
        return 'weibo';
      }
      if (ua.match(/Mobile MQQBrowser/i) == 'mobile mqqbrowser') {
        return 'qq';
      }
      return 'mobileBrowser';
    } else {
      return 'pcBrowser';
    }
  }

  versions = getVersions();
  platform = getPlatform();
  return {
    versions: versions,
    language: language,
    platform: platform
  }
}
/**
 *@author wanzh
 *@version 1.0
 *@description统计浏览数据
 */
/**
 * 浏览器统计脚本
 */
var tjIdName = "tjId";

/**
 * 设置cookieId
 */
function setCookie(c_name, value, expiredays, domain) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  window.document.cookie = c_name + "=" + encodeURIComponent(value) +
    ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) +
    ((domain == null) ? "" : (";path=/;domain=" + domain));
}

/**
 * 获取cookieId
 */
function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = window.document.cookie.match(reg)) {
    return decodeURIComponent(arr[2]);
  } else {
    return null;
  }
}

function setCookie(name, value) {
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  window.document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString();
}

/**
 * 生成tjId
 */
function genTjId() {
  var cookieId = new Date().getTime();
  cookieId = cookieId + "-" + Math.round(Math.random() * 3000000000);
  return cookieId;
}

/**
 * 设置tjId
 */
function setTjId() {
  var cookieId = genTjId();
  setCookie(tjIdName, cookieId, 365);
  return cookieId;
}

/**
 * 获取TjId
 */
function getTjId() {
  var tjId = getCookie(tjIdName);
  if (tjId != null && tjId.length > 0) {
    return tjId;
  } else {
    return setTjId();
  }
}

function getDevice() {
  var ua = window.navigator.userAgent;
  var isIpad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var isIphone = !isIpad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
  var isAndroid = ua.match(/(Android)\s+([\d.]+)/);
  var isMobile = isIphone || isAndroid;
  var device = '';
  if (isIpad) {
    device = 'ipad';
  } else if (isIphone) {
    device = 'iphone';
  } else if (isAndroid) {
    device = 'android';
  } else {
    device = 'pc';
  }
  return device;
}

/**
 * 获取操作系统
 */
function getPlatform() {
  return window.navigator.platform;
}

/**
 * 获取页面title
 */
function getPageTitle() {
  return document.title;
}

function jsonpAjax(src) {
  var script = document.createElement('script');
  script.setAttribute("type", "text/javascript");
  script.src = src;
  document.body.appendChild(script);
}

export function stat(type) {
  var params = {};
  //type小于等于20个字符
  if(type){
    params.type=type;
  }
  var url = '';
  if (window.location.host == 'apph5.ttplus.cn') {
    url = ('https:' == window.location.protocol ? 'https://log.ttplus.cn/weblog/info' : 'http://log.ttplus.cn/weblog/info')
  } else {
    url = ('https:' == window.location.protocol ? 'https://logdev.ttplus.cn/weblog/info' : 'http://logdev.ttplus.cn/weblog/info');
  }
  params.tjid = getTjId();
  //params.ip = document.localName == "undefined"?document.localName:'';
  params.referrer = window.document.referrer;
  params.url = window.location.href;
  params.device = getDevice();
  params.title = getPageTitle();
  var browser = Browser();
  params.platform = browser.platform;
  //params.ua = navigator.userAgent;
  //params.os = getPlatform();
  params.callbackQuery='callback';
  params.callbackName='callback_stat';
  Vue.jsonp(url, params).then(json => {
    console.log('tj success');
    // Success.
  }).catch(err => {
    // Failed.
  })
}



// WEBPACK FOOTER //
// ./src/util/stat.js